/**
 * Terms version sent at signup / accept flows.
 *
 * Deploy checklist when legal bumps terms:
 * - Set server TERMS_VERSION (see server/config/index.js)
 * - Set client REACT_APP_TERMS_VERSION to the same value before frontend build
 * - Mismatch triggers needs_terms_reacceptance for users who already accepted an older version
 *
 * Prefer REACT_APP_TERMS_VERSION at build time; optional fetch: GET /api/terms/current-version
 */
export function getClientTermsVersion() {
    const raw = typeof process !== 'undefined' ? process.env.REACT_APP_TERMS_VERSION : undefined;
    if (typeof raw === 'string' && raw.trim() !== '') {
        return raw.trim();
    }
    return '1.0';
}
